import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class ProblemApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/problem' + path, queryMap);
  }

  findProblemTree(platform_id: number) {
    const q = { platform_id };
    const url = this.buildurl('/tree', q);
    return this.http.fget(url);
  }
}
